import { getLanguage } from './func';

export default function url(url) {

    const language = getLanguage();

    const locale = (language==='en') ? '' : '/'+language;

    return locale+url;
}